import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminAiChat = lazy(() => import("@/pages/admin/AdminAiChat"));

export const Route = createFileRoute("/admin/ai-chatt")({
  component: () => <AdminAiChat />,
});
